@if (showRegimenReorderUI) {
  <ng-container [ngTemplateOutlet]="regimenReorderTemplate"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="standardCheckoutTemplate"></ng-container>
}

<!-- ─── Standard Checkout Template ─── -->
<ng-template #standardCheckoutTemplate>
  <div class="tw-flex tw-flex-col tw-h-full tw-pt-24 tw-overflow-y-auto" id="checkoutPage">
    <loading class="tw-flex-1 tw-justify-self-center tw-self-center" *ngIf="ui.loading || !(defaultAddress$ | async)"></loading>
    <div id="back" class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
    </div>
    <div class="ld-session-block tw-mx-6" *ngIf="defaultAddress$ | async as defaultAddress">
      <div id="address"
           *ngIf="!ui.loading"
           (click)='navigateTo("/user/addresses")'
           class="tw-flex tw-flex-col tw-border tw-gap-4 tw-p-4 tw-border-teal-700 tw-rounded-lg">
        <div class="tw-flex tw-flex-col tw-relative">
          <div class="tw-font-lexend tw-text-100 tw-leading-[21px] tw-text-gray-500  tw-uppercase tw-tracking-[1px] tw-break-words" i18n="@@name">Name</div>
          <cs-icon class="tw-shrink-0 tw-w-4 tw-h-4 tw-text-teal-600 tw-absolute tw-top-0 tw-right-0" [iconName]="'done'"></cs-icon>
          <div id="contact-name" class="tw-break-words value tw-font-lexend tw-font-medium tw-text-400 tw-text-gray-800">
            {{defaultAddress?.contactName}}
          </div>
        </div>
        <div class="tw-flex tw-flex-col">
          <div class="tw-text-100 tw-uppercase tw-break-words tw-font-lexend tw-leading-[21px] tw-text-gray-500" i18n="@@phoneNumber"> Phone Number </div>
          <div id="mobile-number" class="tw-break-words tw-font-lexend tw-font-medium tw-text-400 tw-text-gray-800" *ngIf="!internalUser">
            {{defaultAddress?.mobileNumber || user?.get('MobileNumber')}}
          </div>
        </div>
        <div class="tw-flex tw-flex-col">
          <div class="tw-text-100 tw-uppercase tw-break-words tw-font-lexend tw-leading-[21px] tw-text-gray-500" i18n="@@address"> Address </div>
          <div id="delivery-address" class="tw-break-words tw-font-lexend tw-font-medium tw-text-400 tw-text-gray-800">
            {{getDeliveryAddress(defaultAddress)}}
          </div>
        </div>
        <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-fit tw-py-[5px] tw-pl-4 tw-pr-2 tw-border tw-border-teal-600 tw-rounded-lg">
          <div class="change-add-address tw-tracking-normal tw-font-lexend tw-font-semibold tw-text-300 tw-leading-[21px] tw-text-teal-600" i18n="@@changeAddAddress"> Change or Add address </div>
          <cs-icon class="tw-shrink-0 tw-w-4 tw-h-4 tw-text-teal-600" [iconName]='"chevron_right_teal_rounded"'></cs-icon>
        </div>
      </div>
    </div>
    <div class="tw-flex tw-flex-row tw-items-center tw-px-4 tw-bg-gray-100 tw-rounded-xl tw-mx-6 tw-gap-4 tw-py-2 tw-mt-5" *ngIf="!ui.loading && defaultAddress$ | async">
      <div class="tw-block tw-bg-transparent tw-w-[84px] tw-h-[90px] tw-shrink-0" src="" alt="">
        <img class="tw-w-full tw-h-full tw-object-contain" src="https://cdn.cureskin.com/app/img/order.gif" alt="order"/>
      </div>
      @if (isEnglishOrHindiUser) {
        <div id="dynamic-expected-delivery-date" class="tw-flex-1">
          @if (orderDeliveryDateToCurrentDateDifference <= 3) {
            <span class="tw-text-300 tw-font-lexend tw-text-gray-500" i18n="@@youWillReceiveOn">
              Your order is expected to be delivered on
            </span>
          } @else {
            <span class="tw-text-300 tw-font-lexend tw-text-gray-500" i18n="@@youWillReceiveOn">
              Your order is expected to be delivered on
            </span>
          }
          <ng-container *ngIf="(!expectedDeliveryDate.to && !expectedDeliveryDate.from)">
            <div class="tw-flex tw-justify-center tw-items-center tw-pr-3">
              <loading class="tw-scale-75"></loading>
            </div>
          </ng-container>
          <ng-container>
            @if(orderDeliveryDateToCurrentDateDifference >=0  && orderDeliveryDateToCurrentDateDifference <= 1) {
              <p id="expected-delivery-date-1" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle" i18n="@@byTomorrow">
                by tomorrow
              </p>
            } @else if (orderDeliveryDateToCurrentDateDifference === 2) {
              <p id="expected-delivery-date-2" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle" i18n="@@within2Days">
                within 2 days
              </p>
            } @else if(orderDeliveryDateToCurrentDateDifference === 3) {
              <p id="expected-delivery-date-3" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle" i18n="@@within3Days">
                within 3 days
              </p>
            } @else {
              <p id="expected-delivery-date" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle">
                {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
              </p>
            }
          </ng-container>
        </div>
      } @else {
        <div id="static-expected-delivery-date" class="tw-flex-1">
          <p class="tw-text-300 tw-font-lexend tw-text-gray-500" i18n="@@youWillReceiveOn"> Your order is expected to be delivered on </p>
          <ng-container *ngIf="!expectedDeliveryDate.to && !expectedDeliveryDate.from">
            <div class="tw-flex tw-justify-center tw-items-center tw-pr-3">
              <loading class="tw-scale-75"></loading>
            </div>
          </ng-container>
          <ng-container *ngIf="expectedDeliveryDate.to && expectedDeliveryDate.from">
            <p id="expected-delivery-date-custom" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle">
              {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
            </p>
          </ng-container>
        </div>
      }
    </div>
    <div class="tw-flex-1"></div>
    <div class="flex-footer" *ngIf="!ui.loading && defaultAddress$ | async">
      <div class="tw-w-full" *ngIf="offerTimer.endTime > 0 && typeOfOrder === appConfig.Shared.Order.Type.REGIMEN">
        <discount-timer id="discount-timer" [endTime]="offerTimer.endTime" [text]="offerTimer.title"></discount-timer>
      </div>
      <div class="tw-w-full tw-p-5">
        <button csButton
              id="selectPaymentRebranded"
              type="button"
              class="tw-w-full"
              [loading]="(checkoutInProgress$ | async)"
              (click)="checkout()"
              i18n="@@proceedToPay"
        >Proceed to pay</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- ─── Regimen Reorder Template ─── -->
<ng-template #regimenReorderTemplate>
  <div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden">
    <div class="tw-grid tw-grid-cols-[40px_1fr_40px] tw-w-full tw-h-18 tw-px-6 tw-bg-black tw-z-[100] tw-items-center">
      <div class="tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
      </div>
      <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal tw-justify-self-center" i18n="@@reviewOrder">Review Order</span>
    </div>

    <div class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto">
      <div class="tw-mx-4 tw-mt-3 tw-pb-3 tw-rounded-3 tw-overflow-visible" [class]="isHairRegimen ? 'tw-bg-purple-75' : 'tw-bg-yellow-75'">
        <div class="tw-flex tw-items-start tw-gap-2">
          <div class="tw-pl-4 tw-mt-2 xxs:tw-mt-5 tw-flex-[3_0_calc(52%-4px)]">
            @if (regimenReorderKitDetailsForClass?.regimenClass?.toLowerCase() === ApiClientConstant.Regimen.Class.FACE.toLowerCase()) {
              <p class="tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800 tw-capitalize" i18n="@@yourCompleteSkinKit">Your complete skin kit</p>
            }
            @if (regimenReorderKitDetailsForClass?.regimenClass?.toLowerCase() === ApiClientConstant.Regimen.Class.HAIR.toLowerCase()) {
              <p class="tw-text-400 tw-font-lexend tw-font-bold tw-text-gray-800 tw-capitalize" i18n="@@yourCompleteHairKit">Your complete hair kit</p>
            }
            <p class="tw-font-body tw-text-200 tw-text-gray-800 tw-mt-1" i18n="@@includesProducts"> Includes {{regimenReorderKitDetailsForClass?.products?.length}} products </p>
          </div>
          <div class="tw-flex-[2_0_calc(48%-4px)] tw-flex tw-items-end tw-z-50">
            <img class="tw-w-full tw-h-full tw-object-contain"
              [src]="checkoutKitImage"
              alt="doctor holding kit" />
          </div>
        </div>
        <div class="tw-bg-white tw-rounded-3 tw-mx-2 tw-p-4 -tw-mt-6 tw-relative tw-z-10">
          @for (product of regimenReorderKitDetailsForClass?.products ?? []; track product.objectId) {
            <div class="tw-flex tw-items-center tw-gap-[6px] tw-my-2 first:tw-mt-0 last:tw-mb-0">
              <cs-icon class="tw-w-4 tw-h-4 tw-text-green-500" [iconName]="'green_tick_circle'"></cs-icon>
              <p class="tw-text-300 tw-font-lexend tw-font-normal tw-text-gray-600">
                {{product.title}} - {{product.quantity}} {{product.quantityUnit}}
              </p>
            </div>
          }
        </div>
        @if (shouldShowDoctorCharges) {
          <div class="tw-flex tw-items-center tw-justify-center tw-my-1">
            <span class="tw-text-300 tw-font-body tw-text-gray-600">+</span>
          </div>
          <div class="tw-mx-2 tw-px-3 tw-py-4 tw-border tw-border-dashed tw-border-orange-500 tw-rounded-3">
            <p class="tw-text-300 tw-font-lexend tw-font-bold tw-text-gray-800" i18n="@@2MonthlyDoctorCheckups">2 Monthly Doctor Check-ups</p>
          </div>
        }
      </div>

      <app-to-pay [pricingDetails]="regimenReorderPricingDetails" [bottomsheetData]="regimenReorderBottomsheetData"/>
    </div>

    <div class="tw-shrink-0">
      @if (defaultAddress$ | async; as defaultAddress) {
        <app-delivery-address-bar
          [address]="defaultAddress"
          (changeAddress)="navigateTo('/user/addresses')"
        />
      }

      <div class="tw-py-5 tw-px-6">
        <button csButton
                id="regimenReorderPay"
                type="button"
                class="tw-w-full tw-capitalize"
                i18n="@@proceedToPay"
                [loading]="(checkoutInProgress$ | async)"
                (click)="checkout()"
        >Proceed to pay</button>
        <app-expected-delivery-date
          [expectedDeliveryDate]="expectedDeliveryDate"
          [dayDifference]="orderDeliveryDateToCurrentDateDifference"
        />
      </div>
    </div>
  </div>
</ng-template>
